import { STUDENT_ROUTES, TEACHER_ROUTES } from "@constants/routes";
import { useAuth } from "@contexts/Auth";
import { scrollState } from "@reducers/scroll";
import { useAppSelector } from "@root/hooks";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

type Props = {
  children: React.ReactNode;
};

const ScrollToTop: React.FC<Props> = ({ children }) => {
  const { scrollDisabled } = useAppSelector(scrollState);
  const { pathname, search } = useLocation();
  // the bellow storage is set in: components/Common/ClassNav/PlanClass/Content/ContentCard.tsx
  const isFromClassNav = localStorage.getItem("isFromClassNav");
  const {
    isCurrentRoles: { isStudent, isTeacher },
  } = useAuth();

  useEffect(() => {
    if (
      (isFromClassNav && isStudent && pathname !== STUDENT_ROUTES.ARTICLES) ||
      (isTeacher && pathname !== TEACHER_ROUTES.ARTICLES)
    ) {
      localStorage.removeItem("isFromClassNav");
      localStorage.removeItem("classNavTagInfos");
    }
    // 特定のケースでスクロール位置をリセッ トしない
    if (scrollDisabled) {
      return;
    }
    window.scrollTo(0, 0);
  }, [pathname, search]);

  return <>{children}</>;
};

export default ScrollToTop;
